// extracted by mini-css-extract-plugin
export default {"title-user":"MyEvent_title-user__-NAuG"};